/* Client-side mirror of backend unit conversion. Includes bar units cl/dash/splash. */
const MASS = { g: 1, kg: 1000 };
const VOLUME = { ml: 1, cl: 10, L: 1000, dash: 1, splash: 5 };
const COUNT = { Stueck: 1, Portion: 1 };

export function convertQty(qty, fromUnit, toUnit) {
  if (!qty || fromUnit == null || toUnit == null) return null;
  if (fromUnit === toUnit) return qty;
  if (fromUnit in MASS && toUnit in MASS) return (qty * MASS[fromUnit]) / MASS[toUnit];
  if (fromUnit in VOLUME && toUnit in VOLUME) return (qty * VOLUME[fromUnit]) / VOLUME[toUnit];
  if (fromUnit in COUNT && toUnit in COUNT) return (qty * COUNT[fromUnit]) / COUNT[toUnit];
  return null;
}

export function lineCost(qty, lineUnit, ingredient) {
  if (!ingredient) return { cost: 0, incompatible: false };
  const conv = convertQty(qty, lineUnit, ingredient.unit);
  if (conv == null) return { cost: 0, incompatible: true };
  return { cost: conv * (ingredient.price_per_unit || 0), incompatible: false };
}

export const UNIT_COMPATIBLE = (a) => {
  if (a === "g" || a === "kg") return ["g", "kg"];
  if (a === "ml" || a === "cl" || a === "L") return ["ml", "cl", "L"];
  if (a === "Stueck" || a === "Portion") return ["Stueck", "Portion"];
  return ["g", "kg", "ml", "cl", "L", "Stueck", "Portion"];
};

/* For cocktail recipe lines — adds dash & splash to any volume-compatible base. */
export const COCKTAIL_LINE_UNITS_FOR = (baseUnit) => {
  if (baseUnit === "ml" || baseUnit === "cl" || baseUnit === "L") return ["ml", "cl", "L", "dash", "splash"];
  if (baseUnit === "Stueck" || baseUnit === "Portion") return ["Stueck"];
  return ["ml", "cl", "L", "dash", "splash", "Stueck"];
};
